import { decodeName } from './decodeName';
import { normalizeNodeSeo } from './seoMetrics';
import type { ClusterSeoMetrics, HierarchicalNode } from '../types';

/** Map leaf keyword label -> seo metrics from hierarchical JSON. */
export function buildLeafSeoIndex(
  root: HierarchicalNode | null | undefined
): Map<string, ClusterSeoMetrics> {
  const index = new Map<string, ClusterSeoMetrics>();

  function walk(node: HierarchicalNode | null | undefined): void {
    if (!node) return;
    const children = node.children ?? [];
    if (!children.length) {
      index.set(decodeName(node.name), normalizeNodeSeo(node));
      return;
    }
    children.forEach(walk);
  }

  walk(root);
  return index;
}
